export default "__VITE_ASSET__VabVZmzb__"